import React, { useCallback } from 'react';
import { NoSidebarPageLayout } from '@insurancemenu/imenu-components-lib';
import {
  SUBSCRIBER_CARD_DATA,
  getSubscriberTaskChecklistURL,
} from 'global/checklists-helpers/SubscriberChecklistHelper';
import useSubscriberTaskUrlParams from 'global/hooks/useSubscriberTaskUrlParams';
import { bpHistory } from 'global/bpHistory';

const QuoteManageElectionsPage: React.FC = () => {
  const { groupId, subscriberId, entityId } = useSubscriberTaskUrlParams();
  const returnBack = useCallback((): void => {
    bpHistory.push(
      getSubscriberTaskChecklistURL({
        entityId,
        subId: subscriberId,
        groupId,
      }),
    );
  }, [entityId, subscriberId, groupId]);

  return (
    <NoSidebarPageLayout
      contentWidth="standard"
      isInitialLoading={false}
      isInfoSectionLoading={false}
      // moreInfoBlob={buildGroupContextMoreInfoBlobProps({
      //   blobTitle: group?.name || '',
      //   generalInfoMap: { group: group?.name || '' },
      //   contactInfoMap: buildGroupContactInfoMap(group?.contactInfo ?? null),
      // })}
      pageHeader={{
        title: SUBSCRIBER_CARD_DATA.QUOTING_ELECTIONS.title,
        subtitle: SUBSCRIBER_CARD_DATA.QUOTING_ELECTIONS.text,
        onBackButtonClick: returnBack,
      }}
    >
      {null}
    </NoSidebarPageLayout>
  );
};

export default QuoteManageElectionsPage;
